
import { Component, Vue } from "vue-property-decorator";
import { apiShopShopStatistics } from "@/api/shop";
import { RequestPaging } from "@/utils/util";
import LsPagination from "@/components/ls-pagination.vue";
@Component({
  components: {
    LsPagination,
  },
})
export default class shopOrderStatistics extends Vue {
  $refs!: {
    form: any;
  };

  pager = new RequestPaging();
  form: any = {
    shop_info: "",
    field: "",
    order_by: "",
    start_time: "",
    end_time: "",
  };

  time: string[] = [];

  // 排序选项配置
  sortOptions = [
    { field: "orders_count", label: "订单数量" },
    { field: "orders_sum", label: "订单金额" },
    { field: "order_transfer_count", label: "转单数量" },
    { field: "order_transfer_sum", label: "转单金额" },
  ];

  // 日期选择器配置
  pickerOptions = {
    shortcuts: [
      {
        text: "最近一周",
        onClick(picker: any) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit("pick", [start, end]);
        },
      },
      {
        text: "最近一个月",
        onClick(picker: any) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
          picker.$emit("pick", [start, end]);
        },
      },
      {
        text: "最近三个月",
        onClick(picker: any) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
          picker.$emit("pick", [start, end]);
        },
      },
    ],
  };
  changeSort(field: string) {
    if (this.form.field !== field) {
      this.form.field = field;
      this.form.order_by = "asc";
    } else {
      this.form.order_by = this.form.order_by === "asc" ? "desc" : "asc";
    }
    this.getList();
  }
  changeDate(e: any) {
    this.time = e;
    this.form.start_time = e[0];
    this.form.end_time = e[1];
    this.getList();
  }
  getList(page?: number): void {
    page && (this.pager.page = page);
    this.pager.request({
      callback: apiShopShopStatistics,
      params: this.form,
    });
  }

  created() {
    this.pager.size = 20
    this.getList();
  }
}
